import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from "react-helmet-async";
export const SEO = ({ title, description, image }) => {
    return (_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { name: "description", content: description }), image && _jsx("meta", { name: "image", content: image }), _jsx("meta", { property: "og:title", content: title }), _jsx("meta", { property: "og:description", content: description }), image && _jsx("meta", { property: "og:image", content: image })] }));
};
export default SEO;
//# sourceMappingURL=SEO.js.map